import React, { useState } from "react";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import Module_Buyer_Pop from "./Module_Buyer_Pop";

export const Sub_Explore_image_ = () => {
  const [buyers] = useState([
    {
      id: 1,
      country: "IN",
      title: "Fresh fruits like green banana",
      date: "Sep 20, 2024",
      verified: true,
      rating: 4.5,
      reviews: 5,
      description:
        "We are seeking quotations from reputable suppliers for the procurement of high-quality fresh fruits. Our goal is to ensure a consistent supply of fresh produce to meet our business needs and customer demands.",
    },
    {
      id: 2,
      country: "IN",
      title: "Fresh fruits like green banana",
      date: "Sep 20, 2024",
      verified: true,
      rating: 4.5,
      reviews: 5,
      description:
        "We are seeking quotations from reputable suppliers for the procurement of high-quality fresh fruits. Our goal is to ensure a consistent supply of fresh produce to meet our business needs and customer demands.",
    },
    {
      id: 3,
      country: "IN",
      title: "Fresh fruits like green banana",
      date: "Sep 20, 2024",
      verified: true,
      rating: 4.5,
      reviews: 5,
      description:
        "We are seeking quotations from reputable suppliers for the procurement of high-quality fresh fruits. Our goal is to ensure a consistent supply of fresh produce to meet our business needs and customer demands.",
    },
    {
      id: 4,
      country: "IN",
      title: "Fresh fruits like green banana",
      date: "Sep 20, 2024",
      verified: true,
      rating: 4.5,
      reviews: 5,
      description:
        "We are seeking quotations from reputable suppliers for the procurement of high-quality fresh fruits. Our goal is to ensure a consistent supply of fresh produce to meet our business needs and customer demands.",
    },
  ]);

  const [selectedBuyer, setSelectedBuyer] = useState(null);

  return (
    <div className="w-5/6 py-5">
      <div className="flex p-2 justify-center items-center mt-7 gap-2">
        <span
          data-tooltip-id="hotProductsTooltip"
          data-tooltip-html={`
            <div class='tooltip-bubble bg-blue-500 text-white p-2'>
              <div class='tooltip-content'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.<br />
                Nullam id nulla a elit pharetra gravida. Sed porttitor sapien non ex malesuada.
              </div>
              <div class='tooltip-tail'></div>
            </div>
          `}
          className="text-2xl mt-1 cursor-pointer"
        >
          <HiOutlineInformationCircle />
        </span>
        <h1 className="font-semibold text-2xl w-[45%]">
          High Demand / Hot Enquiries
        </h1>
        <Tooltip
          id="hotProductsTooltip"
          place="bottom"
          offset={10}
          className="!bg-transparent !p-0 !rounded-none ms-28"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {buyers.map((buyer) => (
          <div
            key={buyer.id}
            className="bg-white px-5 py-3 w-full rounded-lg shadow border"
          >
            {/* ✅ Aligned Top Row */}
            <div className="flex justify-between items-start flex-wrap">
              <div className="flex items-center flex-wrap gap-x-1 text-sm font-medium text-gray-800">
                <img
                  src="https://flagcdn.com/in.svg"
                  alt="IN"
                  className="w-5 h-4 object-cover"
                />
                <span>IN</span>
                <span className="text-gray-500">Wanted :</span>
                <span className="text-sky-600 underline font-semibold cursor-pointer">
                  {buyer.title}
                </span>
              </div>

              <div className="flex items-center gap-1 text-xs text-gray-500">
                <span>{buyer.date}</span>
                <HiOutlineInformationCircle className="w-3 h-3" />
              </div>
            </div>

            {/* Verified + Rating */}
            <div className="mt-2 flex items-center space-x-2 text-sm">
              <span className="text-gray-800 font-semibold">
                Buyer From India
              </span>
              {buyer.verified && (
                <>
                  <span className="bg-blue-100 text-blue-600 px-2 py-0.5 rounded font-bold text-xs">
                    Verified
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-blue-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4M12 2a10 10 0 100 20 10 10 0 000-20z"
                    />
                  </svg>
                </>
              )}
              <span className="text-red-500">
                {buyer.rating} / {buyer.reviews} review
              </span>
            </div>

            {/* Description */}
            <p className="mt-2 text-sm text-gray-700">
              {buyer.description}{" "}
              <span
                className="text-sky-600 underline cursor-pointer ml-1"
                onClick={() => setSelectedBuyer(buyer)}
              >
                More
              </span>
            </p>

            {/* Popup Modal */}
            <Module_Buyer_Pop
              buyer={selectedBuyer}
              onClose={() => setSelectedBuyer(null)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
